import React from "react";
import PayoutWorkspace from "./PayoutWorkspace";
const CheckPayout = props => <PayoutWorkspace mode="check" history={props.history} />;
export default CheckPayout;
